import { render, staticRenderFns } from "./DeleteItem.vue?vue&type=template&id=4ef4e380&scoped=true&"
import script from "./DeleteItem.vue?vue&type=script&lang=ts&"
export * from "./DeleteItem.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteItem.vue?vue&type=style&index=0&id=4ef4e380&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef4e380",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAvatar,VBtn})
